export default __webpack_public_path__ + "static/media/Clear.eec1aaac.svg";